/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Full_Title4Inputs */

const en_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete architecture`)
};

const ar_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية متكاملة`)
};

const bn_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পূর্ণ আর্কিটেকচার`)
};

const de_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige Architektur`)
};

const es_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura completa`)
};

const fr_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture complète`)
};

const pt_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura completa`)
};

const zh_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整架构`)
};

const tr_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksiksiz mimari`)
};

const ru_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная архитектура`)
};

const pl_svc_full_stack_web_apps_full_title4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompletna architektura`)
};

/**
* | output |
* | --- |
* | "Complete architecture" |
*
* @param {Svc_Full_Stack_Web_Apps_Full_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_full_title4 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Full_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Full_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_full_title4(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_full_title4(inputs)
	return en_svc_full_stack_web_apps_full_title4(inputs)
});
export { svc_full_stack_web_apps_full_title4 as "svc_full-stack-web-apps_FULL_title" }